import React, { memo } from 'react'
import { Handle } from '@xyflow/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faBuilding,
    faTrash,
    faUserPlus,
} from '@fortawesome/free-solid-svg-icons'

// تعریف نود جدید با دو ایکون
export const DepartmentNode = ({ data }) => {
    const { label, handlerAddDepartment, onClickIcon2 } = data

    return (
        <div className="departmentNode">
            <div className="departmentNode-label">{label}</div>
            <div className="departmentNode-box-icons">
                <span
                    onClick={() => {
                        handlerAddDepartment()
                    }}
                    className="departmentNode-department"
                >
                    <FontAwesomeIcon icon={faBuilding} />
                </span>
                <span
                    onClick={onClickIcon2}
                    className="departmentNode-position"
                >
                    <FontAwesomeIcon icon={faUserPlus} />
                </span>
                <span className="departmentNode-trash">
                    <FontAwesomeIcon icon={faTrash} />
                </span>
            </div>
            <Handle type="source" position="bottom" />
            <Handle type="target" position="top" />
        </div>
    )
}

export default memo(DepartmentNode)
